'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

var _traits = require('./traits');

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_BOOKMAKER_OFFER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferButtonClicked() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_BUTTON_CLICKED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_BUTTON_CLICKED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferButtonClicked;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackRacecardOfferButtonClicked.js
// module id = 1340
// module chunks = 1